import Vue from 'vue';
import productGroupTransformer from './../../transformers/productGroup';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(productGroupTransformer.fetch(errors));
};

export default (id, productGroup) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .put(`/product_groups/${id}`, productGroup)
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/product-group/update.js